import type { TooltipRenderProps } from "react-joyride";
import Button from "~/components/button.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import CrossIcon from "~/components/icons/cross.tsx";
import ProgressDots from "~/components/progress-dots.tsx";
import classes from "./editor-tooltip.module.css";

function EditorTooltip({
	skipProps,
	primaryProps,
	index,
	size,
	step: {
		data: { title },
		content,
	},
}: TooltipRenderProps) {
	const t = useTranslator();
	return (
		<div className={classes["editor-tooltip"]}>
			<div className={classes["container"]}>
				<button
					type="button"
					onClick={skipProps.onClick as any}
					className={classes["close-button"]}
				>
					<CrossIcon size={12} />
				</button>
				<div className={classes["content"]}>
					<div className={classes["heading"]}>{title}</div>
					<div className={classes["content-text"]}>{content}</div>
				</div>
				<div className={classes["footer"]}>
					<ProgressDots total={size} currentIndex={index} />
					<Button
						type="button"
						variant="blue"
						onClick={primaryProps.onClick as any}
						className={classes["next-button"]}
					>
						{index < size - 1 ? t("Next") : t("Done")}
					</Button>
				</div>
			</div>
		</div>
	);
}

export default EditorTooltip;
